import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Wifi, Car, Accessibility, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { IMAGES } from "@/data/site";

const features = [
  { icon: ShieldCheck, label: "Hospital-grade sterilization" },
  { icon: Wifi, label: "Modern digital equipment" },
  { icon: Car, label: "Convenient parking" },
  { icon: Accessibility, label: "Easy accessibility" },
];

export const ClinicShowcase = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.1, 1.25]);

  return (
    <section ref={ref} data-testid="clinic-section" className="bg-brand-soft">
      <div className="mx-auto max-w-[1440px] px-6 pt-24 md:px-12 md:pt-32 lg:px-20 lg:pt-40">
        <Reveal className="mb-12 max-w-3xl">
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-brand-blue">
            Our Dental Clinic
          </span>
          <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.02] tracking-tight text-brand-dark md:text-5xl lg:text-6xl">
            A modern dental clinic in <span className="italic text-brand-blue">Paharia</span>
          </h2>
        </Reveal>
      </div>

      <div className="relative h-[60vh] w-full overflow-hidden md:h-[70vh]">
        <motion.img
          src={IMAGES.clinic1}
          alt="Dr. Ankesh Seth clinic interior"
          loading="lazy"
          style={{ y, scale }}
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-accent/70 via-brand-accent/10 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 mx-auto grid max-w-[1440px] grid-cols-2 gap-4 px-6 pb-10 md:grid-cols-4 md:px-12 lg:px-20">
          {features.map((f, i) => (
            <Reveal
              key={f.label}
              delay={i * 0.08}
              className="flex items-center gap-3 rounded-2xl border border-white/15 bg-white/10 px-4 py-3 backdrop-blur-md"
            >
              <f.icon className="h-5 w-5 shrink-0 text-brand-green" />
              <span className="text-sm font-semibold text-white">{f.label}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
